export default function propsProvider(props) {
    /*
      - To only list utilized props
      - Wrapping utilized props on each view
  */
    const {
        intl,
        rowCount,
        handleEditClick,
        handleAddClick,
        handleCloseDialog,
        handleDeleteClick,
        columns,
        data,
        addressData,
        handleSubmit,
        openDialog,
        initialValues,
        keyword,
        setKeyword,
        isAdd,
        pageSize,
        setPageSize,
        tableData,
        currentPage,
        setCurrentPage,
        handleChangeCurrentPage,
    } = props;
    return {
        intl,
        handleEditClick,
        handleAddClick,
        handleCloseDialog,
        handleDeleteClick,
        columns,
        data,
        rowCount,
        addressData,
        handleSubmit,
        openDialog,
        initialValues,
        keyword,
        setKeyword,
        isAdd,
        pageSize,
        setPageSize,
        tableData,
        currentPage,
        setCurrentPage,
        handleChangeCurrentPage,
    };
}
